module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Battery-charging-644cdb1ab0152851c64e07b0b42ce55a.svg";